import {
  Database,
  DatabaseEntry,
  DatabaseField,
  ImportedFileType,
} from '@databases/types/database';
import {
  getDatabaseEntryOptional,
  getDatabaseFieldOptional,
} from '@databases/utils/database/utils';

import {
  ImportEntryMode,
  ImportEntryReference,
  ImportFieldMode,
  ImportFieldReference,
} from '../types';

/**
 * The supported import MIME types.
 */
export const supportedImportMimeTypes: Record<string, ImportedFileType> = {
  'text/csv': ImportedFileType.CSV,
  'text/plain': ImportedFileType.CSV, // CSV file type for macOS
  'text/tab-separated-values': ImportedFileType.CSV,
  'application/vnd.ms-excel': ImportedFileType.CSV, // CSV file type for Windows
};

export function resolveFieldReference(
  database: Database,
  fieldRef: ImportFieldReference | undefined
): DatabaseField | undefined {
  if (fieldRef?.type === ImportFieldMode.EXISTING) {
    return getDatabaseFieldOptional(database, fieldRef.fieldId);
  } else if (fieldRef?.type === ImportFieldMode.CREATE) {
    return fieldRef.field;
  }
}

export function resolveEntryReference(
  database: Database,
  entryRef: ImportEntryReference | undefined
): DatabaseEntry | undefined {
  if (entryRef?.type === ImportEntryMode.EXISTING) {
    return getDatabaseEntryOptional(database, entryRef.entryId);
  } else if (entryRef?.type === ImportEntryMode.CREATE) {
    return entryRef.entry;
  }
}

/**
 * An unreachable case that helps ensure the capture of uncovered cases
 * by explicitly making typescript error when used in conjunction
 * with a switch statement.
 */
export const unreachable = (value: never) => {
  throw new Error(`Not implemented: ${value}`);
};
